// @ts-nocheck
import { TaxExemptionCertificateCollectionModel } from "@store/Framework/Types/ApiModels";
import {
    getTaxExemptionCertificates,
    GetTaxExemptionCertificatesApiParameter,
} from "@store/Framework/Services/TaxExemptionCertificatesService";
import { ApiHandler, createHandlerChainRunner } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = ApiHandler<GetTaxExemptionCertificatesApiParameter, TaxExemptionCertificateCollectionModel>;

export const DispatchBeginLoadTaxExemptionCertificates: HandlerType = props => {
    props.dispatch({
        type: "Greif/Data/TaxExemptionCertificates/BeginLoadTaxExemptionCertificates",
        parameter: props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getTaxExemptionCertificates(props.apiParameter);
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 404)) {
            props.dispatch({
                type: "Greif/Data/TaxExemptionCertificates/FailedToLoadTaxExemptionCertificates",
            });
            return false;
        }

        throw error;
    }
};

export const DispatchCompleteLoadTaxExemptionCertificates: HandlerType = props => {
    props.dispatch({
        type: "Greif/Data/TaxExemptionCertificates/CompleteLoadTaxExemptionCertificates",
        collection: props.apiResult,
        parameter: props.parameter,
    });
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadTaxExemptionCertificates,
    RequestDataFromApi,
    DispatchCompleteLoadTaxExemptionCertificates,
];

const loadTaxExemptionCertificates = createHandlerChainRunner(chain, "LoadTaxExemptionCertificates");
export default loadTaxExemptionCertificates;
